export const SubjectTypesNamespace = 'subjectTypes'
